/** @format */

import {
  Box,
  Button,
  styled,
  TableBody,
  TableContainer,
  TableHead,
  TextField,
  Typography,
} from '@mui/material';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';
import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';

export const Header = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(6),
}));

export const Title = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_1?.main,
  fontSize: '32px',
  fontWeight: 300,
  lineHeight: '40px',
}));

export const Subtitle = styled(Typography)(({theme}) => ({
  maxWidth: '600px',
  color: theme.palette.figma_gray_light_1?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const Controls = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
  gap: theme.spacing(3),
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

export const SearchContainer = styled(Box)(({theme}) => ({
  flex: 1,
  maxWidth: '400px',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const SearchField = styled(TextField)(({theme}) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    '& fieldset': {
      borderColor: theme.palette.action.active,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.action.hover,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.action.selected,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(3, 4),
    color: theme.palette.text.primary,
  },
}));

export const ActionsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    width: '100%',
  },
}));

export const ActionButton = styled(Button)(({theme}) => ({
  borderRadius: '8px',
  height: '48px',
  background: theme.palette.figma_gray_dark_1?.main,
  color: theme?.palette.figma_gray_middle_dark?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const StyledTableContainer = styled(TableContainer)(({theme}) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: '1px solid #2A2A2A',
  marginBottom: theme.spacing(6),
  '& .MuiTable-root': {
    backgroundColor: 'transparent',
  },
}));

export const StyledTableHead = styled(TableHead)(({theme}) => ({
  '& .MuiTableCell-head': {
    backgroundColor: theme.palette.figma_gray_dark?.main,
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '16px',
    padding: theme.spacing(3),
    border: 'none',
    borderBottom: '1px solid #2A2A2A',
    '&:first-of-type': {
      paddingLeft: theme.spacing(4),
    },
    '&:last-child': {
      paddingRight: theme.spacing(4),
    },
  },
}));

export const StyledTableBody = styled(TableBody)(({theme}) => ({
  '& .MuiTableRow-root': {
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
    },
    '&:last-child .MuiTableCell-body': {
      borderBottom: 'none',
    },
  },
  '& .MuiTableCell-body': {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    padding: theme.spacing(3),
    border: 'none',
    borderBottom: '1px solid #2A2A2A',
    '&:first-of-type': {
      paddingLeft: theme.spacing(4),
    },
    '&:last-child': {
      paddingRight: theme.spacing(4),
    },
  },
}));

export const CheckboxCell = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const Footer = styled(Box)(({theme}) => ({
  position: 'fixed',
  bottom: 0,
  background: theme.palette.background?.default,
  width: '100vw',
  height: theme.spacing(20),
  paddingBlock: theme.spacing(4),
}));

export const SaveButton = styled(PrimaryMediumButton)(({theme}) => ({
  minWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const BackButton = styled(SecondaryMediumButton)(({theme}) => ({
  minWidth: '160px',
  color: 'white',
  marginLeft: theme.spacing(4),
  background: '#202020',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },

  '&:hover': {
    background: '#2a2a2a',
  },
}));
